/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/12/2021
 */

import GenogramItem from "@shared/Genogram/GenogramItem.js";
import {AgeDateDisplayEnum} from "@shared/Genogram/AgeDateDisplayEnum";
import dayjs from "dayjs";

const ZoomLevelEnum = Object.freeze({
	BIRD_EYE: 0.1,
	MIDDLE: 0.5,
	CLOSEUP: 1,
})

let LabelMinZoomVisibilityMap = {
	"name": ZoomLevelEnum.CLOSEUP,
	"age": ZoomLevelEnum.MIDDLE,
	"origin": ZoomLevelEnum.MIDDLE,
	"emotions": ZoomLevelEnum.MIDDLE,
	"coreBeliefs": ZoomLevelEnum.MIDDLE,
	"activationResponse": ZoomLevelEnum.MIDDLE,
	"copingStrategies": ZoomLevelEnum.MIDDLE,
	"intensity": ZoomLevelEnum.MIDDLE,
	"healingProgress": ZoomLevelEnum.MIDDLE,
	"bodyLocation": ZoomLevelEnum.MIDDLE,
	"notePublic": ZoomLevelEnum.MIDDLE,

}

export default class IFSPartsItem extends GenogramItem {

	constructor(clientId) {
		super(clientId);
	}

	setDefault(){
		// this.jsonData = {
		// 	boxSelectionEnabled: false,
		// 	elements: {
		// 		nodes: [
		// 			{
		// 				data: {
		// 					id: 1712231247759,
		// 					isCoreSelf: true,
		// 					instanceLimit: 1,
		// 					type: "ellipse",
		// 					name: "Self",
		// 					label: "Self",
		// 					resize: true,
		// 					bg: "#0EEA2D",
		// 					width: 176,
		// 					height: 176,
		// 					size: 4,
		// 					nonDeletable: false,
		// 					showNotes: true,
		// 				},
		// 				position: {
		// 					x: 332.5,
		// 					y: 332.5
		// 				},
		// 				group: "nodes",
		// 				removed: false,
		// 				selected: false,
		// 				selectable: true,
		// 				locked: false,
		// 				grabbable: true,
		// 				pannable: false,
		// 				classes: 0
		// 			}
		// 		]
		// 	},
		// 	pan: {
		// 		x: 93,
		// 		y: -96
		// 	},
		// 	panningEnabled: true,
		// 	userPanningEnabled: true,
		// 	userZoomingEnabled: true,
		// 	zoom: 1,
		// 	zoomingEnabled: true
		// }

		// this.jsonData = {"boxSelectionEnabled":false,"elements":{"nodes":[{"data":{"id":"1712231247759","isCoreSelf":true,"instanceLimit":1,"type":"ellipseNoImage","name":"Self","label":"Self","resize":true,"bg":"#0EEA2D", "opacity": 0.45, "border": true, "width":200,"height":200,"size":4,"nonDeletable":false,"showNotes":true},"position":{"x":297.5,"y":402.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1717018240798","type":"triangle","name":"My Firefighter","label":"My Firefighter","resize":true,"bg":"#7e0bf8","width":76,"height":76,"showNotes":true,"points":[-1,1,1,1,0,-1,-1,1]},"position":{"x":192.5,"y":157.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1717018242717","type":"rectangle","name":"My Manager","label":"My Manager","resize":true,"bg":"#1f70ff","width":76,"height":76,"showNotes":true},"position":{"x":-17.5,"y":367.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1717018252565","type":"diamond","name":"My Exile","label":"My Exile","resize":true,"bg":"#fcc510","width":76,"height":76,"showNotes":true,"points":[-1,1,1,1,0,-1,-1,1]},"position":{"x":122.5,"y":577.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"}],"edges":[{"data":{"source":"1717018242717","target":"1717018240798","id":"1717018254013","lineType":"bezier","title":"Hostile","lineSubType":"hostile1"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""},{"data":{"source":"1717018242717","target":"1717018252565","id":"1717018265783","lineType":"bezier","title":"Controlling","lineSubType":"controlling"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""},{"data":{"source":"1712231247759","target":"1717018252565","id":"1717018320603","lineType":"bezier","title":"Emotional Abuse","lineSubType":"abuse3"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""}]},"pan":{"x":238.3981707176768,"y":3.4647818686245557},"panningEnabled":true,"userPanningEnabled":true,"userZoomingEnabled":true,"zoom":0.6546361740672757,"zoomingEnabled":true}
		this.jsonData = {"boxSelectionEnabled":false,"elements":{"nodes":[{"data":{"id":"1717018240798","type":"triangle","name":"My Firefighter","label":"My Firefighter","resize":true,"bg":"#7e0bf8","width":76,"height":76,"showNotes":true,"points":[-1,1,1,1,0,-1,-1,1]},"position":{"x":787.5,"y":122.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1717018242717","type":"rectangle","name":"My Manager","label":"My Manager","resize":true,"bg":"#1f70ff","width":76,"height":76,"showNotes":true},"position":{"x":-17.5,"y":122.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1717018252565","type":"diamond","name":"My Exile","label":"My Exile","resize":true,"bg":"#fcc510","width":76,"height":76,"showNotes":true,"points":[-1,1,1,1,0,-1,-1,1]},"position":{"x":332.5,"y":1067.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1746359841072","type":"coreSelf","name":"Self","label":"Self","width":176,"height":176,"isCoreSelf":true,"isExcluded":false,"instanceLimit":1,"size":2,"nonDeletable":false,"showNotes":true,"bg":"#0EEA2D","opacity":1,"border":true,"bg-opacity":0.2},"position":{"x":367.5,"y":542.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":""}],"edges":[{"data":{"source":"1717018242717","target":"1717018252565","id":"1717018265783","lineType":"bezier","title":"Controlling","lineSubType":"controlling"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""},{"data":{"source":"1717018242717","target":"1717018240798","id":"1717018254013","lineType":"bezier","title":"Hostile","lineSubType":"hostile1"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""}]},"pan":{"x":299.1918258286215,"y":67.96286826961034},"panningEnabled":true,"userPanningEnabled":true,"userZoomingEnabled":true,"zoom":0.3372873086588702,"zoomingEnabled":true}
	}


	updateNodeLabel(nodeData) {
		let age = null
		let dateOfBirth = null
		let dateOfDeath = null
		if (nodeData.dateOfBirth) {
			let rightDate = dayjs()
			if (nodeData.isPassedAway && nodeData.dateOfDeath) {
				rightDate = dayjs(nodeData.dateOfDeath)
			}
			age = rightDate.diff(dayjs(nodeData.dateOfBirth), 'year')
		}
		if (nodeData.dateOfBirth) {
			dateOfBirth = "Born: " + dayjs(nodeData.dateOfBirth).format(nodeData.birthFormat || "MMM DD, YYYY")
		}
		if (nodeData.isPassedAway && nodeData.dateOfDeath) {
			let text = ""
			if(nodeData.dateOfBirth && age && age <= 0){
				text = "Stillbirth or miscarriage: "
			} else {
				text = "Passed away: "
			}
			dateOfDeath = text + dayjs(nodeData.dateOfDeath).format(nodeData.deathFormat || "MMM DD, YYYY")
		}
		if(age !== null){
			if (age === 0) {
				age = 'Infant'
			} else {
				age = age + " y.o."
			}
		}
		switch (this.ageDateDisplay) {
			case AgeDateDisplayEnum.AGE_ONLY:
				dateOfBirth = null
				break
			case AgeDateDisplayEnum.DATE_ONLY:
				age = null
				break
			case AgeDateDisplayEnum.FULL:
				break
		}
		let notePublic = nodeData.notePublic ? "\n" + nodeData.notePublic : null
		let textLine = [nodeData.relationship, nodeData.gender, age].filter(item => !!item).join(", ")
		nodeData.label = [nodeData.name, textLine, dateOfBirth, dateOfDeath, notePublic].filter(item => !!item).join(",\n")
	}
}
